import defaultConfig from './defaultConfig';
import topStoresPersonalizedConfig from './topStoresPersonalizedConfig';

export default {
  defaultConfig,
  topStoresPersonalizedConfig,
};
